import axios from "axios";

import { PatientModel, PlatformType } from "graphql/generated";
import { config } from "src/config";

import { getTracking, getUtm } from "../utils/tracking";

// @deprecated
export const track = async (metric: string, metadata: object, patient?: PatientModel) => {
  return;
  const tracking = getTracking();
  const session = patient?.email;
  if (!session || !metric) {
    return;
  }
  const url = `${config.API_URI}/tracking`;
  await axios.post(url, {
    store: process.env.NEXT_PUBLIC_COUNTRY,
    platform: patient?.fromPlatformEnv || PlatformType.Noah,
    source: "frontend",
    metric,
    email: session,
    metadata,
    utm: getUtm(),
    tracking
  });
};

export type SegmentData = {
  segmentType: "page" | "track" | "identify";
  event?: string;
  name?: string;
  category?: string;
  userId?: string;
  anonymousId?: string;
  properties?: any;
};
export const trackSegment = async (data: SegmentData) => {
  try {
    const url = `${config.API_URI}/tracking/segment`;
    await axios.post(url, {
      ...data
    });
    // eslint-disable-next-line no-empty
  } catch (e) {}
};
